import { CalendarSlash, EyeSlash, Prohibit, Rows } from '@phosphor-icons/react';
import { users as usersApi } from '../../api/endpoints';
import { SubScreen } from '../../components/layout/Screens';
import { SettingGroup, SettingRow } from '../../components/ui/Bits';
import { useAsync } from '../../hooks/useAsync';
import { t } from '../../i18n';

/* Un nombre a droite quand la liste contient quelque chose ; rien sinon. */
const combien = (n: number | undefined) => (n ? String(n) : undefined);

/**
 * Ce qu'on a ecarte de sa vue, en quatre listes.
 *
 * Les comptes masques, les comptes bloques, les posts et les evenements
 * masques : des gestes differents, qu'on retrouve au meme endroit pour
 * pouvoir revenir dessus. Les evenements avaient deja leur liste, ouverte
 * depuis l'onglet des sorties ; elle s'ouvre aussi d'ici, sous une adresse
 * des reglages pour que le retour y ramene. Masquer n'est pas bloquer —
 * voir `blocks.listHidden` — et les deux listes de comptes restent
 * separees pour que la difference se lise.
 *
 * Chaque rangee dit combien sa liste contient, pour savoir avant d'ouvrir.
 * La page se relit a chaque retour : on vient souvent d'en vider une.
 */
export function HiddenBlockedScreen() {
  const { data: nombres } = useAsync(() => usersApi.ecartes(), [], 'masques-nombres');

  return (
    <SubScreen title={t.profil.masques.titre}>
      <SettingGroup>
        <SettingRow
          icon={<EyeSlash size={22} />}
          label={t.profil.masques.comptesMasques}
          value={combien(nombres?.comptesMasques)}
          to="/app/profile/settings/masques/comptes"
        />
        <SettingRow
          icon={<Prohibit size={22} />}
          label={t.profil.masques.comptesBloques}
          value={combien(nombres?.comptesBloques)}
          to="/app/profile/settings/blocked"
        />
        <SettingRow
          icon={<Rows size={22} />}
          label={t.profil.masques.postsMasques}
          value={combien(nombres?.posts)}
          to="/app/profile/settings/masques/posts"
        />
        <SettingRow
          icon={<CalendarSlash size={22} />}
          label={t.sorties.masques.titre}
          value={combien(nombres?.evenements)}
          to="/app/profile/settings/masques/sorties"
        />
      </SettingGroup>
    </SubScreen>
  );
}
